import { AccountingResponse, AccountingService } from '@api'
import { useQuery } from 'react-query'

import { unescapeHtmlText } from '@/modules/chatting/ui/chat-window/fan-info/utils'
import { handleError } from '@/utils/error'
import { dateToString } from '@/utils/helpers'

interface UseAccountingDataParams {
  from?: Date
  to?: Date
}

export function useAccountingData({ from, to }: UseAccountingDataParams) {
  const {
    data: accountingData,
    isLoading,
    refetch,
  } = useQuery(
    ['accounting_data', from, to],
    async () => {
      if (!from || !to) {
        return
      }

      return AccountingService.createAccountingStatement({
        from: dateToString(from),
        to: dateToString(to),
      })
    },
    {
      cacheTime: 0,
      refetchInterval: 60000,
      onError: (error) =>
        handleError(error, 'Failed to get accounting data', refetch),
    },
  )

  return {
    accountingData:
      accountingData &&
      ({
        ...accountingData,
        creatorStatistics: accountingData.creatorStatistics?.map((item) => ({
          ...item,
          creatorName: unescapeHtmlText(item.creatorName),
        })),
      } as AccountingResponse),
    isLoading,
  }
}
